import React from 'react';
import { Box, Typography, styled } from '@material-ui/core';

import { useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import { OnboardingPopover } from '../OnboardingPopover';

import { OnboardingParams } from '@/pages/Onboarding/types';
import { getProductEmail } from '@/utils/productHelpers';

const ContentContainer = styled(Box)(({ theme }) => ({
  color: theme.palette.grey[800],
  '& > *': {
    marginTop: 24,
  },
}));

const PopoverContent: React.FC<{ personEnrolling: string }> = ({ personEnrolling }) => {
  const { product } = useParams<OnboardingParams>();
  const { t } = useTranslation();

  return (
    <ContentContainer>
      <Typography variant="h2">
        {t(`coverage.${product}.${personEnrolling}.info_popup.title`)}
      </Typography>
      <Typography>
        {
          t(`coverage.${product}.${personEnrolling}.info_popup.disclose`)
        }
      </Typography>
      <ul>
        <li>
          <Typography variant="body2">
            {t(`coverage.${product}.${personEnrolling}.info_popup.disclose_list.0`)}
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            {t(`coverage.${product}.${personEnrolling}.info_popup.disclose_list.1`)}
          </Typography>
        </li>
      </ul>
      <Typography>
        {t(`coverage.${product}.${personEnrolling}.info_popup.alert`)}
        {' '}
        <b>
          {t(`coverage.${product}.${personEnrolling}.info_popup.safety_risk`)}
        </b>
      </Typography>
      <Typography>
        {t(`coverage.${product}.${personEnrolling}.info_popup.questions`)}
        {' '}
        {getProductEmail(product)}
      </Typography>
    </ContentContainer>
  );
};

interface WhyDoWeNeedThisInfoProps {
  personEnrolling: 'patient' | 'caregiver';
  popoverOpen: boolean;
  setPopoverOpen: (arg0: boolean) => void;
}

export const WhyDoWeNeedThisInfo: React.FC<WhyDoWeNeedThisInfoProps> = ({
  personEnrolling,
  popoverOpen,
  setPopoverOpen,
}) => (
  <OnboardingPopover
    popoverOpen={popoverOpen}
    setPopoverOpen={setPopoverOpen}
  >
    <PopoverContent personEnrolling={personEnrolling} />
  </OnboardingPopover>
);
